module.exports = __webpack_public_path__ + "public/images/lightbulb.0281a05384bedecec34231c0d753542a.png";